import { client } from "api";

export type SetBatchProcessedRequest = {
  absenceIds: string[];
  processed: boolean;
};

export type SetBatchProcessedResponse = string;

export const batchUpdateProcessed = (
  request: SetBatchProcessedRequest
): Promise<SetBatchProcessedResponse> =>
  client
    .patch<SetBatchProcessedResponse>("/absence/batch-update-processed", request)
    .then((res) => res.data);
